module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a99c058"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/Profile/Edit/EditPage.vue
// module id = 1041
// module chunks = 1